// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useContext, useEffect } from 'react'
import { AuthContext } from 'components/Auth'
import { SignIn } from 'components'
import pageView from 'helpers/googleAnalytics/pageView'
import Banner from './Banner'
import ActivationPending from './ActivationPending'
import Footer from './Footer'
import CTAButtons from './CTAButtons'

const HomePage = () => {
  const {
    groups,
    user,
  } = useContext(AuthContext)

  useEffect(() => {
    document.title = 'Comsearch Connect'
    // NOTE - this is based on hash routing.
    pageView(window.location.hash.slice(1), document.title)
  }, [])

  if (!user) {
    return <SignIn />
  }

  return (
    <>
      <Banner />
      {
        groups.length
          ? <CTAButtons />
          : <ActivationPending />
      }
      <Footer />
    </>
  )
}

export default HomePage
